import { useState, useEffect } from "react";
import { fetchWithCache } from "../utils/apiCache";

export const formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
};

export const useProjects = () => {
    const [projectsData, setProjectsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                const url = `${process.env.REACT_APP_BACKEND_URL}/projects/`;
                const result = await fetchWithCache(url);
                
                if (result.status === 200 && result.data) {
                    const sortedProjects = result.data.sort((a, b) => b.id - a.id);
                    setProjectsData(sortedProjects);
                } else {
                    setProjectsData([]);
                }
            } catch (err) {
                console.error("Failed to fetch projects:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchProjects();
    }, []);

    return { projectsData, loading, error, formatDate };
};
